module.exports = __webpack_public_path__ + "fancy.png?40573f9b730911546ff8c1d183efb30d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fancy.png
// module id = 8
// module chunks = 0